import React from "react";
import {  Switch, Route,Link } from "react-router-dom";

import { useSelector } from "react-redux";

import Loading from "./components/Loading/Loading";
import loadable from '@loadable/component';
import CreateContent from "./components/Create/CreateContent";
let lazyLoad =   <Loading/>;
  ;
const Navber = loadable(() => import("./Navbar/UserMenu"), {
  fallback: lazyLoad  });

      const CreateCourse = loadable(() => import("./components/Create/CreateCourse"), {
        fallback: lazyLoad  });
function HomeCreateContent() {
  

 
   
   const localToken= localStorage.getItem("profile");
   const token = useSelector((state)=>state?.user?.user?.token);
  
  
   return (<>
   

<Switch>
  <div className="outer-all ">
  <div></div>
  <div className = "ikcraft_login-signup-right-signup"  id="outer-left">

 

<div style={{padding:'5px',fontSize:'18px',color:'#958FDA',textAlign:'center',marginTop:"70px"}} >  

  
{(token===localToken&&token&&localToken)?
  <>
<Navber/>
</>  :<>
{/* <Link to="/signup">
  <div  className="ikcraft_login-input-card">
   
  <button  className="ikcraft_login-signup-button" type="submit" id="signupBtn">Sign Up </button>
      
  </div></Link>

<Link to="/login">
  <div  className="ikcraft_login-input-card">
   
  <button  className="ikcraft_login-signup-button" type="submit" id="signupBtn">Login </button>
      
  </div></Link>
  <Link to="/loginWithOTP">
  <div  className="ikcraft_login-input-card">
   
  <button  className="ikcraft_login-signup-button" type="submit" id="signupBtn">Login With OTP </button>
      
  </div></Link> */}
  </>}
  </div>

  </div>
 <div className="outer-right">
 <div className="content-topk"></div> 

 <Route  path="/create-content" component={CreateContent}/>
</div></div> 

</Switch>
    </>
  );
};
export default HomeCreateContent;






